import Request from 'modules/request';
const aivaContentId = 'aiva-content';

export default class Aiva {

  HdShSidebar() {
      const idAivaSidebar = "aiva-sidebar";
      const sidebar = document.getElementById(idAivaSidebar);

      const classHide = "sidebar-hd";
      const classShow = "sidebar-sh";
      const classBtn  = "sidebar-btn";

      const buttons = document.getElementsByClassName(classBtn);
      const aivaContent = document.getElementById('aiva-content');

      if (sidebar.classList.contains(classHide)) {
        sidebar.classList.remove(classHide);
        sidebar.classList.add(classShow);
        // fix width aiva-content
        if (window.innerWidth > 720) {
          aivaContent.style = "";
        }
        // mostrar texto span do button
        for (let button of buttons) {
          button.lastElementChild.style.display = "block";
          button.style.justifyContent = "space-between";
        }
        return;
      }
      sidebar.classList.remove(classShow);
      sidebar.classList.add(classHide);

      // fix width aiva-content
      if (window.innerWidth > 720) {
        aivaContent.style.width ="calc(100% - 50px)";
      }

      for (let button of buttons) {
        button.lastElementChild.style.display = "none";
        button.style.justifyContent = "center";
      }
  }

  // get partials
  Map(url) {
      const request = new Request();
      request.get(url, (request, response) => {
        const map_partial = response.data;
        const aivaContent = document.getElementById(aivaContentId);
        aivaContent.innerHTML = map_partial;
      });
  }

  DeviceNew(url) {
    const request = new Request();
    request.get(url, (request, response) => {
      const device_partial = response.data;
      const aivaContent = document.getElementById(aivaContentId);
      aivaContent.innerHTML = device_partial;
    });
  }

  Devices(url) {
    const request = new Request();
    request.get(url, (request, response) => {
      const devices_partial = response.data;
      const aivaContent = document.getElementById(aivaContentId);
      aivaContent.innerHTML = devices_partial;
    });
  }

  DevicesJson(url = '/aiva/devices/json') {
    const request = new Request();
    request.get(url, (request, response) => {
      const list = JSON.parse(response.data).devices;
      let i = 0;
      while (i < list.length) {
        this.Subscription(list[i].name)
        i++;
      }
    });
  }

  // subscription chat_device
  Subscription(deviceId)
  {
    return consumer.subscriptions.create({ channel: "DeviceChannel", device_id: deviceId }, {
      connected() {
        // Called when the subscription is ready for use on the server
        console.log("Conectado ao canal do dispositivo " + deviceId);
      },

      disconnected() {
        // Called when the subscription has been terminated by the server
      },

      received(data) {
        // Called when there's incoming data on the websocket for this channel
        console.log("Mensagem recebida:", data);
        // inserir device que enviou mensagem em msg-content
        if (!document.getElementById(`${deviceId}-message-symbol`))
        {
          const allChats = document.getElementById("box-all-chats");
          window.Aiva.listDeviceReceived(deviceId, this);
          window.Aiva.createChat(allChats, deviceId, this);
        }
        // popular chat com dados
        window.Aiva.fillChat(deviceId, data);
      },
      sendMessage(msg) {
        this.perform("sendMessage", {device_id: deviceId, content: msg});
      }
    });
  }

  HideShow(id)
  {
    let msgsFill = document.getElementById(id);
    if (msgsFill.classList.contains("show"))
    {
      msgsFill.className = "messages-box hide";
    } else {
      msgsFill.className = "messages-box show";
    }
  }

  listDeviceReceived(deviceId, context)
  {
    // pai que recebe o nome do device que enviou a mensagem
    const msgContent = document.getElementById("msg-content");
    //criar um elemento que simboliza o device dentro do pai
    const device = document.createElement("button");
    device.id = `${deviceId}-message-symbol`;
    device.className = "btn-card-msg";
    device.innerHTML = deviceId;

    // abrir chat com o device
    device.onclick = (e) => {
      // inserir chat ao body allChats
      const allChats = document.getElementById("box-all-chats");
      const deviceChat = document.getElementById(`${deviceId}-chat`);
      deviceChat.style.display = "grid";
      const icNot = document.getElementById(`${deviceId}-chat-ic-newmsg`);
      icNot.style = "";
    }
    const notifierBox = document.createElement("div");
    notifierBox.className="notifier-flex";
    let icNewMsg = document.createElement("div");
    icNewMsg.className = "notifier-new-msg";
    icNewMsg.id = `${deviceId}-chat-ic-newmsg`;
    device.appendChild(icNewMsg);
    notifierBox.appendChild(device);
    // inserir ao pai
    msgContent.appendChild(notifierBox);
  }

  createChat(parentBox, deviceId, context)
  {
    // box do chatDevice
    const deviceChat = document.createElement("div");
    deviceChat.className = "device-chat";
    deviceChat.id = `${deviceId}-chat`;
    // box mostrar nome do device e hora atual
    const headDevice = document.createElement("div");
    headDevice.className = "head-device";
    headDevice.id = `${deviceId}-chat-head`;
    let deviceName = document.createElement("span");
    deviceName.innerHTML = deviceId;
    headDevice.appendChild(deviceName);
    let dateTime = document.createElement("span");
    dateTime.innerHTML = "00000000";
    let btnClose = document.createElement("button");
    btnClose.innerHTML = "Fechar";
    btnClose.onclick = () => {
      deviceChat.style = "none";
      const icNot = document.getElementById(`${deviceId}-chat-ic-newmsg`);
      icNot.style = "";
    }
    headDevice.appendChild(btnClose);
    // box exbir todas as mensagens
    const chatMsgs = document.createElement("div");
    chatMsgs.className = "chat-messages";
    chatMsgs.id = `${deviceId}-chat-messages`;
    // box com input para enviar mensagem
    const sendMsgBox = document.createElement("div");
    sendMsgBox.className = "box-field-msg";
    sendMsgBox.id = `${deviceId}-send-msg-chat`;
    const input = document.createElement("input");
    input.type = "text";
    input.id = `${deviceId}-input-field-chat`;
    const sendMs = document.createElement("button");
    sendMs.innerHTML = "Enviar";
    sendMs.onclick = (e) => {
      let msg = document.getElementById(`${deviceId}-input-field-chat`).value;
      let userName = document.getElementById("current_user").innerHTML;
      context.sendMessage({sended: true, text:msg, user: userName});
      input.innerHTML = "";
      input.value = "";
      chatMsgs.scrollTop = chatMsgs.scrollHeight+250;
    };
    sendMsgBox.appendChild(input);
    sendMsgBox.appendChild(sendMs);
    deviceChat.appendChild(headDevice);
    deviceChat.appendChild(chatMsgs);
    deviceChat.appendChild(sendMsgBox);
    parentBox.appendChild(deviceChat);
    return 1;
  }

  fillChat(deviceId, data)
  {
    const chat = document.getElementById(`${deviceId}-chat-messages`);
    const icNot = document.getElementById(`${deviceId}-chat-ic-newmsg`);
    icNot.style.display = "block";
    if (data.message.content.sended)
    {
      let sendedMs = document.createElement("div");
      sendedMs.className = "bl-msg send";
      let msg = document.createElement("span");
      msg.innerHTML = data.message.content.text;
      sendedMs.appendChild(msg);
      chat.appendChild(sendedMs);
    } else {
      const receivedMs = document.createElement("div");
      receivedMs.className = "bl-msg";
      const msg = document.createElement("span");
      msg.innerHTML = data.message.content.text;
      receivedMs.appendChild(msg);
      chat.appendChild(receivedMs);
    }
    chat.scrollTop = chat.scrollHeight+50;
  }
  // power management
  RestartDevice(id)
  {
    aivaChannel.perform("fluidpc", {info:{"machineId": id, "objectId": "", "action": "Restart"}});
  }

  ShutDownDevice(id)
  {
    aivaChannel.perform("fluidpc", {info:{"machineId": id, "objectId": "", "action": "Shutdown"}});
  }

  // cloner management
  ClonerPhysicalDriveTNet(machineId, srcDisk, dstDisk)
  {
    // init cloner net
    aivaChannel.perform("fluidpc", {info:{"machineId": machineId, "objectId": "", "action": "CloneDiskNet", "srcDisk": srcDisk, "dstDisk": dstDisk}});
  }

  // Logical Disks
  CreateDisk(pcID, index, object)
  {
    let disk = document.createElement('div');
    disk.id = `${pcID}-logical-${object.letterUnit}`;
    disk.className = "disk";
    //letter
    let letter = document.createElement("span");
    letter.id = `${pcID}-logical-name-${index}-${object.letterUnit}`;
    letter.innerHTML = "Mounted as "+object.letterUnit+" ";
    //sizes
    let sizes = document.createElement("span");
    sizes.id = `${pcID}-logical-sizes-${index}`;
    sizes.innerHTML = `${object.totalSizeUnit}GB`;
    // graphics
    let fi = document.createElement("div");
    fi.className = "fi";
    let inuse = document.createElement("span"); 
    inuse.innerHTML = "USAGE";
    fi.appendChild(inuse);
    let boxGraph = document.createElement("div");
    boxGraph.className = "box-graph";
    let freeSpace = document.createElement("i");
    freeSpace.id = `${pcID}-free-${object.letterUnit}`;
    freeSpace.innerHTML = `${object.availableFreeSpace}GB`;
    boxGraph.appendChild(freeSpace);
    let graphDown = document.createElement("div");
    graphDown.className = "graph-down";
    let upProg = document.createElement("div");
    upProg.className = "up prog";
    upProg.id = `${pcID}-logicalprog-${object.letterUnit}`;
    let percent = object.totalSizeUnit - object.availableFreeSpace;
    percent = percent * 100;
    percent = percent / object.totalSizeUnit;
    upProg.style = "width:"+percent+"%";
    graphDown.appendChild(upProg);
    let totalSpace = document.createElement("i");
    totalSpace.id = `${pcID}-Ltotalspace-${object.letterUnit}`;
    totalSpace.innerHTML = `${object.totalSizeUnit}GB`;
    boxGraph.appendChild(graphDown);
    boxGraph.appendChild(totalSpace);
    fi.appendChild(boxGraph);
    disk.appendChild(letter);
    disk.appendChild(sizes);
    disk.appendChild(fi);
    return disk;
  }

  CreateDiskHard(pcID, index, object)
  {

    let disk = document.createElement('div');
    disk.id = `${pcID}-logical-${object.letterUnit}`;
    disk.className = "disk";
    disk.onclick = () => {
      // selecionar disco destino para clonagem
        if (destinationBody.children.length < 2) {
          destinationBody.appendChild(disk);
          selectedDiskId = disk;
        } else {
          bodyDisks.appendChild(disk);
          selectedDiskId = null;
        }
    }
    //letter
    let letter = document.createElement("span");
    letter.id = `${pcID}-logical-name-${index}-${object.letterUnit}`;
    letter.innerHTML = object.name+" "+object.letterUnit+" ";
    //sizes
    let sizes = document.createElement("span");
    sizes.id = `${pcID}-logical-sizes-${index}`;
    sizes.innerHTML = ` ${object.totalSize}`;
    // graphics
    let fi = document.createElement("div");
    fi.className = "fi";
    let inuse = document.createElement("span"); 
    inuse.innerHTML = "USAGE";
   
    let boxGraph = document.createElement("div");
    boxGraph.className = "box-graph";
    let freeSpace = document.createElement("i");
    freeSpace.id = `${pcID}-free-${object.letterUnit}`;
    freeSpace.innerHTML = `${object.availableFreeSpace}GB`;
    boxGraph.appendChild(freeSpace);
    let graphDown = document.createElement("div");
    graphDown.className = "graph-down";
    let upProg = document.createElement("div");
    upProg.className = "up prog";
    upProg.id = `${pcID}-logicalprog-${object.letterUnit}`;
    let percent = object.totalSizeUnit - object.availableFreeSpace;
    percent = percent * 100;
    percent = percent / object.totalSizeUnit;
    upProg.style = "width:"+percent+"%";
    graphDown.appendChild(upProg);
    let totalSpace = document.createElement("i");
    totalSpace.id = `${pcID}-Ltotalspace-${object.letterUnit}`;
    totalSpace.innerHTML = `${object.totalSizeUnit}`;
    boxGraph.appendChild(graphDown);
    boxGraph.appendChild(totalSpace);
    fi.appendChild(boxGraph);
    disk.appendChild(letter);
    disk.appendChild(sizes);
    disk.appendChild(fi);
    return disk;
  }

  CalcPercent(totalSize, freeSize)
  {
     let percent = totalSize - freeSize;
    percent = percent * 100;
    percent = percent / totalSize;
    return percent;
  }

  UpdateHours(deviceId, timestamp)
  {
    const gridhours = document.getElementById(`${deviceId}-timestamp-stream`);    
    if (gridhours)
    {
      gridhours.innerHTML = timestamp;
    } else {
      const insert = document.getElementById(`${deviceId}-head`);
      insert.insertAdjacentHTML("beforeend", `<div id="${deviceId}-timestamp-stream" class="block-cpu-timestamp"><span style="font-size:16px;margin:0;">${timestamp}</span></div>`);
    }

  }

  UpdateCpuInfo(deviceId, object)
  {
    const insert = document.getElementById(`${deviceId}-lan-performance`);
    const cpuGHZ = document.getElementById(`${deviceId}-cpu-ghz`);
    if (cpuGHZ)
    {
      cpuGHZ.style = `width:${object.cpuinfo}%;`;
      document.getElementById(object.id+"-cputemp-small").innerHTML = object.cputemp+"ºC";
      document.getElementById(object.id+"-cpuprog").style.width = object.cpuinfo+"%";
      document.getElementById(object.id+"-cpupercent").innerHTML = object.cpuinfo+"%";
      document.getElementById(object.id+"-cputempprog").style.width = object.cputemp+"%";
      document.getElementById(object.id+"-cputemp").innerHTML = object.cputemp+"°C";
      document.getElementById(object.id+"-circlea-inner").innerHTML = object.cputemp+"°C";
    } else if(insert) {
      insert.insertAdjacentHTML("afterbegin", `<div class="block-cpu-name"><span class="gradient-text cpu-name-text">${object.cpuname}</span><div class="box-graph"><div class="graph-down"><div  id="${deviceId}-cpu-ghz" class="cpu prog" style="width:${object.cpuinfo}%;"></div></div></div></div>`);
    }
  }

  UpdateRamInfo(object)
  {
    let insert = document.getElementById(object.id+"-raminf");
    if (insert)
    {
      insert.innerHTML = "";
      document.getElementById(object.id+"-raminf").insertAdjacentHTML("beforeend", `<span style="font-size:12px;margin-top:5px;color:#d4d4ed;">${object.ramdisponible} / </span>`);
      document.getElementById(object.id+"-raminf").insertAdjacentHTML("beforeend", `<span style="font-size:12px;margin-top:5px;color:#d4d4ed;">${object.ramtotal}</span>`);
      document.getElementById(object.id+"-ramprog").style.width = object.raminfo+"%";
      document.getElementById(object.id+"-rampercent").innerHTML = object.raminfo+"%";
    }
    
  }

  UpdateDownUpprog(object)
  {
    let downprogsm = document.getElementById(object.id+"-downprog-small");
    let percent = (object.download * 100) / object.speedlink;

    let downprog = document.getElementById(object.id+"-downprog");
    if (downprog) {
      downprogsm.style.width = Math.round(percent)+"%";
      downprog.style.width = Math.round(percent)+"%";
      document.getElementById(object.id+"-downpercent-small").innerHTML = Math.round(percent)+"%";
      document.getElementById(object.id+"-downpercent").innerHTML = Math.round(percent)+"%";
      
      let upprog = document.getElementById(object.id+"-upprog");
      let upprogsm = document.getElementById(object.id+"-upprog-small");
      let percentup = (object.upload * 100) / object.speedlink;
      upprogsm.style.width = Math.round(percentup)+"%";
      upprog.style.width = Math.round(percentup)+"%";

      document.getElementById(object.id+"-uppercent-small").innerHTML = Math.round(percentup)+"%";
      document.getElementById(object.id+"-uppercent").innerHTML = Math.round(percentup)+"%";
    }
    let networkDownload = document.getElementById(`${object.id}-network-download`); 
    if (networkDownload)
    {
      networkDownload.innerHTML = object.download+"mb/s";
    }
    let networkUpload = document.getElementById(`${object.id}-network-upload`);
    if (networkUpload)
    {
      networkUpload.innerHTML = object.upload+"mb/s";
    }
  }

  NetworkInfo(object)
  {
    let insert = document.getElementById(object.id+"-insert");
    let cardInf = document.getElementById(`${object.id}-network-info`);
    if (cardInf) {
      let conntype = document.getElementById(`${object.id}-conntype`);
      conntype.innerHTML = object.conntype;
      let ping = document.getElementById(`${object.id}-ping`);
      ping.innerHTML = "Ping:"+object.latencia+"ms";
      let fullSpeed = document.getElementById(`${object.id}-fullspeed`);
      fullSpeed.innerHTML = "Interface speed: "+object.speedlink+"Mb";
    }
    if (insert) {
      insert.innerHTML = "";
      insert.insertAdjacentHTML("beforeend", `<span style="font-size:14px;margin:0;color:#a7a7e1;">IP settings</span>`);
      for (let ip in object.settings.Addresses) {
        insert.insertAdjacentHTML("beforeend", `<span style="text-align:left;font-size:12px;">${object.settings.Addresses[ip]}</span>`);
      }
      for (let dns in object.settings.dns) {
        if (object.settings.gateways[dns] == null) {
          continue;
        }
        insert.insertAdjacentHTML("beforeend", `<span style="text-align:left;font-size:12px;">${object.settings.dns[dns]}</span>`);
      }
      for (let gat in object.settings.gateways) {
        if (object.settings.gateways[gat] == null) {
          continue;
        }
        insert.insertAdjacentHTML("beforeend", `<span style="text-align:left;font-size:12px;">${object.settings.gateways[gat]}</span>`);
      }
    }
        
  }

  viewCloner(dId, currentid, idDisk) {
    let ind = 0;
    let selectedDiskId = null;
    let selectedOriginDiskId = null;
    while(ind < params.data.hardDisks.length) {
      let disk = document.createElement("button");
      disk.className = "btn target-disk";
      disk.id = `${params.data.id}-${params.data.hardDisks[ind].id.replace(/[\\,.]/g, "")}-targetdisk`;
      disk.innerHTML = params.data.hardDisks[ind].name;
      disk.setAttribute("fisical", params.data.hardDisks[ind].id.replace(/[\\,.]/g, ""));
      disk.fisical = params.data.hardDisks[ind].id.replace(/[\\,.]/g, "");
      disk.onclick = () => {
        // selecionar disco destino para clonagem
        if (destinationBody.children.length < 2) {
          destinationBody.appendChild(disk);
          selectedDiskId = disk;
        } else {
          bodyDisks.appendChild(disk);
          selectedDiskId = null;
        }
      };
      if (dId == params.data.hardDisks[ind].id.replace(/[\\,.]/g, ""))
      {
        disk.onclick = () => {};
        originBody.appendChild(disk);
        selectedOriginDiskId = params.data.hardDisks[ind].id.replace(/[\\,.]/g, "");
      } else {
        bodyDisks.appendChild(disk);
      }
      ind++;
    }
    let  clonageArea = document.createElement("div");
    clonageArea.className = "clonage-area";
    clonageArea.appendChild(originBody);
    clonageArea.appendChild(destinationBody);
    let actionBody = document.createElement("div");
    actionBody.className = "action-body";
    let progressCloner = document.createElement("div");
    progressCloner.className = "box-graph";
    let graphPercent = document.createElement("div");
    graphPercent.className = "graph-down";
    graphPercent.insertAdjacentHTML("beforeend", `<div id="${params.data.id}-${selectedOriginDiskId}-prg" class="prog" style="width:0%;border-top-left-radius:0;border-bottom-left-radius:0;"></div>`)
    graphPercent.style = "border-top-left-radius:0;border-bottom-left-radius:0;";
    progressCloner.appendChild(graphPercent);
    progressCloner.insertAdjacentHTML("beforeend",`<i id="${params.data.id}-${selectedOriginDiskId}-line" style="color:white;"></i>`);
    progressCloner.style="float:left;top:30px;position:absolute;margin-left:5px;";
    hClone = htitle.cloneNode(true);
    hClone.innerHTML = "Progress";
    hClone.style = "float:left;color:white;margin-left:5px;";
    actionBody.appendChild(hClone);
    actionBody.appendChild(progressCloner);
    let startClonerBtn = document.createElement("button");
    startClonerBtn.className = "btn-cloner";
    startClonerBtn.id = `${idDisk}-actionbtn-cloner`;
    startClonerBtn.innerHTML = "INICIAR";
    if (params.data.cloneProgress != null)
    {
      startClonerBtn.innerHTML = "CANCELAR";
      if (document.querySelector("[fisical]") && document.querySelector("[fisical]").getAttribute("fisical") == params.data.cloneProgress.dstDisk.replace(/[\\,.]/g, ""))
      {
        selectedDiskId = document.querySelector("[fisical]");
        destinationBody.appendChild(selectedDiskId);
      } else if (bodyDisks.querySelector("[fisical]") && bodyDisks.querySelector("[fisical]").getAttribute("fisical") == params.data.cloneProgress.dstDisk.replace(/[\\,.]/g, "")){
        selectedDiskId = bodyDisks.querySelector("[fisical]");
        selectedDiskId.disabled = true;
        destinationBody.appendChild(selectedDiskId);
      }
      if (params.data.cloneProgress.finished) {
        startClonerBtn.innerHTML = "CONCLUIDO";
      }

    }
    startClonerBtn.onclick = (e, cancel = false) => {
      // saber se o disco destino foi selecionado
      if (selectedDiskId != null)
      {
        if (startClonerBtn.innerHTML == "CANCELAR") {
          startClonerBtn.innerHTML = "AGUARDE";
          aivaChannel.perform("fluidpc", {info:{"machineId": params.data.id, "objectId": "", "srcDisk": selectedOriginDiskId, "dstDisk": selectedDiskId.fisical, "action": "AbortCloneDisk"}});
          startClonerBtn.disabled = true;
          selectedDiskId.removeAttribute("disabled");
          return;
        }
        if (startClonerBtn.innerHTML == "CONCLUIDO")
        {
          startClonerBtn.innerHTML = "INICIAR";
          selectedDiskId.removeAttribute("disabled");
          bodyDisks.appendChild(selectedDiskId);
          selectedDiskId = null;
          let lds = document.getElementById(`${idDisk}-logstatus`);
          lds.innerHTML = "";
          document.getElementById(`${idDisk}-prg`).style.width=`0%`;
          document.getElementById(`${idDisk}-line`).innerHTML="";
          return;
        }
        selectedDiskId.disabled = true;
        console.log("DISCO DE ORIGEM: "+selectedOriginDiskId+" | DISCO DESTINO: "+selectedDiskId.getAttribute("fisical"));
        startClonerBtn.innerHTML = "CANCELAR";
        aivaChannel.perform("fluidpc", {info:{"machineId": params.data.id, "objectId": "", "srcDisk": selectedOriginDiskId, "dstDisk": selectedDiskId.fisical, "action": "CloneDisk"}});
      } else {
        window.alert("ESCOLHA UM DISCO DESTINO.");
      }

    };
    actionBody.appendChild(startClonerBtn);
    let logAndStatus = document.createElement("div");
    logAndStatus.className = "log-status-body";
    logAndStatus.id = `${idDisk}-logstatus`;
    hClone = htitle.cloneNode(true);
    hClone.innerHTML = "Log&Status";
    clonageArea.appendChild(hClone);
    clonageArea.appendChild(logAndStatus);
    clonageArea.appendChild(actionBody);
    bodyClone.appendChild(close);
    bodyClone.appendChild(bodyDisks);
    bodyClone.appendChild(clonageArea);
    document.body.appendChild(bodyClone);
  }
      

  UpdateDisks(object)
  {
    let containerDisk = document.getElementById(object.id+"-container-disks");
    if (containerDisk)
    {
      if (!sessionStorage.getItem(`${object.id}-firstDisks`)) {
        if (diskActions == null){
          diskActions = document.getElementById(object.id+"-disk-actions");
        }
        containerDisk.innerHTML = "";
        sessionStorage.setItem(`${object.id}-firstDisks`, true);
        sessionStorage.setItem(`${object.id}-countDisk`, object.hardDisks.length);
      }
      if (sessionStorage.getItem(`${object.id}-countDisk`) != object.hardDisks.length && object.id != lastParamsDataId) {
        if (diskActions == null){
          diskActions = document.getElementById(object.id+"-disk-actions");
        }
        containerDisk.innerHTML = "";
        sessionStorage.setItem(`${object.id}-firstDisks`, false);
      }
      let i = 0;
      while (i < object.hardDisks.length) 
      {
        // div pai
        let idDisk = object.hardDisks[i].id.replace(/[\\,.]/g, "");
        let currentid = idDisk;
        idDisk = object.id+"-"+idDisk;

        if (document.getElementById(idDisk)) {
          if (document.getElementById(`${idDisk}-prg`) && object.cloneProgress != null) {

            let lds = document.getElementById(`${idDisk}-logstatus`);
            lds.innerHTML = "";
            if (object.cloneProgress.aborted)
            {
              let startClonerBtn = document.getElementById(`${idDisk}-actionbtn-cloner`);
              startClonerBtn.innerHTML = "INICIAR";
              startClonerBtn.removeAttribute("disabled");
            }
            if (object.cloneProgress.finished)
            {
              object.cloneProgress.timetoend = "00:00:00";
              object.cloneProgress.timetoend = "00:00:00";
              object.cloneProgress.progress = "100%";
              document.getElementById(`${idDisk}-actionbtn-cloner`).innerHTML = "CONCLUIDO";
            }
            lds.insertAdjacentHTML("beforeend", `<span style="color:silver;font-size:12px;">Copied: ${object.cloneProgress.totalR}</br>End: ${object.cloneProgress.timetoend}</span>`);
            document.getElementById(`${idDisk}-prg`).style.width=`${object.cloneProgress.progress}`;
            document.getElementById(`${idDisk}-line`).innerHTML=object.cloneProgress.progress;

            let clBtn = document.getElementById(`${object.id}-${currentid}-clonedisk`);
            if (currentid == object.cloneProgress.dstDisk.replace(/[\\,.]/g, ""))
            {
              clBtn.disabled = true;
              clBtn.onclick = () => { window.alert("Este disco é destino esta sendo usado.");};
            } else {
              clBtn.onclick = () => {
                viewCloner(currentid, currentid, idDisk);
              };
            }
          }
          let currentDiskBox = document.getElementById(idDisk);
          let currentSizes = document.getElementById(idDisk+"-sizes");
          if (currentSizes)
          {
            currentSizes.innerHTML ="SIZE: "+object.hardDisks[i].totalSize+" | "+object.hardDisks[i].totalSizeUnit+" | "+object.hardDisks[i].availableFreeSpace+" | "+object.hardDisks[i].usedSpace;

          }
          let currentReadWrite = document.getElementById(idDisk+"-readWrite");
          if (currentReadWrite) 
          {
            currentReadWrite.innerHTML = "READ: "+object.hardDisks[i].readBytes+"KB/s | WRITE: "+object.hardDisks[i].writeBytes+"KB/s";
          }


          let currentDiskProg= document.getElementById(idDisk+"-diskprog");
          let currentLastPercent = document.getElementById(idDisk+"-diskpercent");
          currentLastPercent.innerHTML = `${object.hardDisks[i].percentDiskTime}%`;
          currentDiskProg.style.width = `${object.hardDisks[i].percentDiskTime}%`;

          let currentDiskProgT = document.getElementById(idDisk+"-disktemppercent");
          currentDiskProgT.style.width = `${object.hardDisks[i].temperature}%`;

          let currentLastPercentT = document.getElementById(idDisk+"-disktemp");
          currentLastPercentT.innerHTML = `${object.hardDisks[i].temperature}°C`;
          currentDiskProgT.style.width = `${object.hardDisks[i].temperature}%`;
          if (object.hardDisks[i].DiskHealth != null)
          {
            const iminentFaillure = object.hardDisks[i].DiskHealth.PredictFailure; // false or true
            if (iminentFaillure)
            {
                currentDiskBox.style = "background-color:red;";
                document.getElementById(`${object.id}-${idDisk}-diskname`).innerHTML = `(FALHA EMINENTE) ${object.hardDisks[i].name} ${object.hardDisks[i].letterUnit} ${object.hardDisks[i].driveFormat}`;
            }
          }

        } else {
          /*let cloneDiskActions = diskActions.cloneNode(true);
          let cloneButton = cloneDiskActions.children[0];
          cloneButton.id = `${object.id}-${currentid}-clonedisk`;

          let logButton = cloneDiskActions.children[1];
          logButton.id = `${object.id}-${currentid}-logbutton`;*/
          let disk = document.createElement("div");
          disk.className = "disk";
          disk.id = idDisk;
          /*logButton.onclick = function(e = event.target,diskName= idDisk) {
            const boxLog = document.getElementById("log");
            if (document.getElementById(idDisk+"-LOG")) {
              document.getElementById(idDisk+"-LOG").style = "";
              return;
            }
            let diskLog = document.createElement("div");
            diskLog.id = idDisk+"-LOG";
            diskLog.className = "log-disk";

            let btnClose = document.createElement("button");
            btnClose.ClassName = "btn-log-close";
            btnClose.innerHTML = "Fechar";
            btnClose.onclick = function() {
              document.getElementById(diskLog.id).style.display = "none";
            }
            diskLog.appendChild(btnClose);
            diskLog.insertAdjacentHTML("beforeend", `<span>${diskName}</span>`);
            boxLog.appendChild(diskLog);
          }*/

          /*cloneButton.onclick = function(e = event.target, dId = currentid) {
            viewCloner(dId, currentid, idDisk);
          }
          if (object.cloneProgress != null && currentid == object.cloneProgress.dstDisk.replace(/[\\,.]/g, ""))
          {
            cloneButton.disabled = true;
            cloneButton.onclick = () => { window.alert("Este disco é destino esta sendo usado.");};
          }*/
          let diskName = document.createElement("span");
          diskName.id = `${object.id}-${idDisk}-diskname`;
          diskName.innerHTML = object.hardDisks[i].name+" "+object.hardDisks[i].letterUnit+" "+object.hardDisks[i].driveFormat;

          let sizes = document.createElement("span");
          sizes.id =idDisk+"-sizes";
          sizes.innerHTML ="SIZE: "+object.hardDisks[i].totalSize+" | "+object.hardDisks[i].totalSizeUnit+" | "+object.hardDisks[i].availableFreeSpace+" | "+object.hardDisks[i].usedSpace;

          let readWrite = document.createElement("span");
          readWrite.id =idDisk+"-readWrite";
          readWrite.innerHTML = "READ: "+object.hardDisks[i].readBytes+"KB/s | WRITE: "+object.hardDisks[i].writeBytes+"KB/s";

          // segunda div pai
          let fi = document.createElement("div");
          fi.id = `${object.id}-${idDisk}-fi`;
          fi.className = "fi";

          let inUse = document.createElement("span");
          inUse.innerHTML = "IN USE";

          let boxGraph = document.createElement("div");
          boxGraph.className = "box-graph";

          let firstPercent = document.createElement("i");
          firstPercent.innerHTML = 0;

          let graphDown = document.createElement("div");
          graphDown.className = "graph-down";

          let diskProg = document.createElement("div");
          diskProg.id = `${idDisk}-diskprog`;
          diskProg.className = "up prog";

          let lastPercent = document.createElement("i");
          lastPercent.id = `${idDisk}-diskpercent`;
          lastPercent.innerHTML = `${object.hardDisks[i].percentDiskTime}%`;
          diskProg.style.width = `${object.hardDisks[i].percentDiskTime}%`;

          let boxTemp = document.createElement("div");
          boxTemp.className = "box-graph";
          let firstPercentT = document.createElement("i");
          firstPercentT.innerHTML = 0;
          let graphDownT = document.createElement("div");
          graphDownT.className = "graph-down";
          let diskProgT = document.createElement("div");
          diskProgT.id = `${idDisk}-disktemppercent`;
          diskProgT.className = "up prog";

          let lastPercentT = document.createElement("i");
          lastPercentT.id = `${idDisk}-disktemp`;
          lastPercentT.innerHTML = `${object.hardDisks[i].temperature}ºC`;
          diskProgT.style.width = `${object.hardDisks[i].temperature}%`;

          fi.appendChild(inUse);

          boxGraph.appendChild(firstPercent);
          graphDown.appendChild(diskProg);
          boxGraph.appendChild(graphDown);
          boxGraph.appendChild(lastPercent);
          fi.appendChild(boxGraph);

          boxTemp.appendChild(firstPercentT);
          graphDownT.appendChild(diskProgT);
          boxTemp.appendChild(graphDownT);
          boxTemp.appendChild(lastPercentT);
          fi.appendChild(boxTemp);
          //cloneDiskActions.style = "";
          //disk.appendChild(cloneDiskActions);
          disk.appendChild(diskName);
          //disk.appendChild(sizes);
          //disk.appendChild(readWrite);
          disk.appendChild(fi);
          containerDisk.appendChild(disk);
        }

        i++;
      }
        
    }
  }

  UpdateLogicalDisks(object)
  {
    // LogicalDisks
    let containerLogicalDisks = document.getElementById(`${object.id}-logical-disks`);
    if (containerLogicalDisks)
    {
      containerLogicalDisks.innerHTML = "";
      let li = 0;
      while (li < object.LogicalDisks.length)
      {
        if (!document.getElementById(`${object.id}-logical-${object.LogicalDisks[li].letterUnit}`)) 
        {
          let diskL = this.CreateDisk(object.id, li, object.LogicalDisks[li]);
          containerLogicalDisks.appendChild(diskL);
        }
        if (document.getElementById(`${object.id}-free-${object.LogicalDisks[li].letterUnit}`))
        {
          document.getElementById(`${object.id}-free-${object.LogicalDisks[li].letterUnit}`).innerHTML = `${object.LogicalDisks[li].availableFreeSpace}GB`;
          document.getElementById(`${object.id}-logicalprog-${object.LogicalDisks[li].letterUnit}`).style.width = `${this.CalcPercent(object.LogicalDisks[li].totalSizeUnit, object.LogicalDisks[li].availableFreeSpace)}%`;
        }
        
        li++;
      }
    }   
  }

  UpdateHardDiskClonner(object)
    {
      // LogicalDisks
      let containerLogicalDisks = document.getElementById(`${object.id}-logical-disks`);
      if (containerLogicalDisks)
      {
        containerLogicalDisks.innerHTML = "";
        let li = 0;
        while (li < object.hardDisks.length)
        {
          if (!document.getElementById(`${object.id}-logical-${object.hardDisks[li].letterUnit}`)) 
          {
            let diskL = this.CreateDiskHard(object.id, li, object.hardDisks[li]);
            containerLogicalDisks.appendChild(diskL);
          }
          if (document.getElementById(`${object.id}-free-${object.hardDisks[li].letterUnit}`))
          {
            document.getElementById(`${object.id}-free-${object.hardDisks[li].letterUnit}`).innerHTML = `${object.hardDisks[li].availableFreeSpace}`;
            document.getElementById(`${object.id}-logicalprog-${object.hardDisks[li].letterUnit}`).style.width = `${this.CalcPercent(object.hardDisks[li].totalSizeUnit, object.LogicalDisks[li].availableFreeSpace)}%`;
          }
          
          li++;
        }
      }
    } 

  SettingAlertColorGraphDown(object)
  {
    let gradleView = document.getElementById(`${object.id}-gradle`);
    if (!gradleView)
    {
      return;
    }
    if (object.cpuinfo <= 40) {
          document.getElementById(object.id+"-cpuprog-small").style = `width:${object.cpuinfo}%;background:cyan;`;
        }
        if (object.cpuinfo > 40) {
          document.getElementById(object.id+"-cpuprog-small").style = `width:${object.cpuinfo}%;`;
        }
        if (object.cpuinfo > 70) {
          document.getElementById(object.id+"-cpuprog-small").style = `width:${object.cpuinfo}%;background:red;`;
        }
        document.getElementById(object.id+"-cpupercent-small").innerHTML = object.cpuinfo+"%";

        if (object.cputemp <= 40) {
          document.getElementById(object.id+"-cputempprog-small").style = `width:${object.cputemp}%;background:cyan;`;
          document.getElementById(object.id+"-circlea").style.background = `conic-gradient(#067de5 ${object.cputemp}%, #1e1c23ba ${object.cputemp}%)`;
        }
        if (object.cputemp > 40) {
          document.getElementById(object.id+"-cputempprog-small").style = `width:${object.cputemp}%;`;
          document.getElementById(object.id+"-circlea").style.background = `conic-gradient(orange ${object.cputemp}%, #1e1c23ba ${object.cputemp}%)`;
        }
        if (object.cputemp > 70) {
          document.getElementById(object.id+"-cputempprog-small").style = `width:${object.cputemp}%;background:red;`;
          document.getElementById(object.id+"-circlea").style.background = `conic-gradient(red ${object.cputemp}%, #1e1c23ba ${object.cputemp}%)`;
        }
  }

  UpdatePrinters(object)
  {
    const containerPrinters = document.getElementById(object.id+"-container-printers");
    if (!containerPrinters)
    {
      return;
    }
    let pi = 0;
    while(pi < object.printers.length){
      let testPrint = null;
      let jobsCount = null;
      let port = null;
      let status = null;
      let defaultP = null;
      let printerStatus = null;
      let workOffline = null;
      // se a impressora ja foi listada
      if (document.getElementById(`${object.id}-${object.printers[pi].Name}`))
      {
        // atualizar status de teste imressao e IMPRESSORA
        testPrint = document.getElementById(`${object.id}-${object.printers[pi].Name}-testprint`);
        if (object.printers[pi].Jobs != "0" || object.printers[pi].PrinterStatus != "3 (Printing (imprimindo))") {
          testPrint.disabled = "disabled";
          testPrint.innerHTML = "Aguarde...";
        } else {
          testPrint.removeAttribute("disabled");
          testPrint.className = "print-test";
          testPrint.innerHTML = "Teste impressão";
        }
        jobsCount = document.getElementById(`${object.id}-${object.printers[pi].Name}-jobscount`);
        jobsCount.innerHTML = `Fila de impressão: ${object.printers[pi].Jobs}`;

        port = document.getElementById(`${object.id}-${object.printers[pi].Name}-portprinter`);
        port.innerHTML = "Port: +"+object.printers[pi].Port;

        status = document.getElementById(`${object.id}-${object.printers[pi].Name}-statusp`);
        status.innerHTML = "Status: "+object.printers[pi].Status;

        defaultP = document.getElementById(`${object.id}-${object.printers[pi].Name}-isdefault`);
        defaultP.innerHTML = "Default: "+object.printers[pi].Default;

        printerStatus = document.getElementById(`${object.id}-${object.printers[pi].Name}-printerstatus`);
        printerStatus.innerHTML = "PrinterStatus: "+object.printers[pi].PrinterStatus+" | "+object.printers[pi].Error;

        workOffline = document.getElementById(`${object.id}-${object.printers[pi].Name}-workoffline`);
        workOffline.innerHTML = "WorkOffline: "+object.printers[pi].WorkOffline;
        pi++;
        continue;
      }
      let printer = document.createElement("div");
      printer.className = "device-lan printer";
      printer.id = `${object.id}-${object.printers[pi].Name}`;
      let name = document.createElement("span");
      name.innerHTML = "Name: "+object.printers[pi].Name;
      testPrint = document.createElement("button");
      testPrint.id = `${object.id}-${object.printers[pi].Name}-testprint`;
      let printName = object.printers[pi].Name;
      testPrint.onclick = (e, mcId = object.id, objId = printName, act = "TestPrint") => {
        aivaChannel.perform("fluidpc", {info:{"machineId": mcId, "objectId": objId, "action": act}});
        testPrint.innerHTML = "Aguarde..";
        testPrint.disabled = "disabled";
      }
      testPrint.className = "print-test";
      testPrint.innerHTML = "Teste impressão";

      jobsCount = document.createElement("span");
      jobsCount.id = `${object.id}-${object.printers[pi].Name}-jobscount`;
      jobsCount.innerHTML = `Fila de impressão: ${object.printers[pi].Jobs}`;

      port = document.createElement("span");
      port.id = `${object.id}-${object.printers[pi].Name}-portprinter`;
      port.innerHTML = "Port: +"+object.printers[pi].Port;

      status = document.createElement("span");
      status.id = `${object.id}-${object.printers[pi].Name}-statusp`;
      status.innerHTML = "Status: "+object.printers[pi].Status;

      defaultP = document.createElement("span");
      defaultP.id = `${object.id}-${object.printers[pi].Name}-isdefault`;
      defaultP.innerHTML = "Default: "+object.printers[pi].Default;

      printerStatus = document.createElement("span");
      printerStatus.id = `${object.id}-${object.printers[pi].Name}-printerstatus`;
      printerStatus.innerHTML = "PrinterStatus: "+object.printers[pi].PrinterStatus+" | "+object.printers[pi].Error;

      workOffline = document.createElement("span");
      workOffline.id = `${object.id}-${object.printers[pi].Name}-workoffline`;
      workOffline.innerHTML = "WorkOffline: "+object.printers[pi].WorkOffline;

      printer.appendChild(testPrint);
      printer.appendChild(name);
      printer.appendChild(port);
      printer.appendChild(status);
      printer.appendChild(defaultP);
      printer.appendChild(jobsCount);
      printer.appendChild(printerStatus);
      printer.appendChild(workOffline);
      containerPrinters.appendChild(printer);
      pi++;
    }
      
  }

  Gradle(deviceName, gradle_url)
  {
    const request = new Request();
    request.get(gradle_url, (request, response) => {
      const _partial = response.data;
      const insert = document.getElementById(`${deviceName}-content-device-info`);
      insert.innerHTML = _partial;
    });
  }

  ClonnerView(deviceId, clonner_url)
  {
    const request = new Request();
    request.get(clonner_url, (request, response) => {
      const _partial = response.data;
      const insert = document.getElementById(`${deviceId}-content-device-info`);
      insert.innerHTML = _partial;
    });
  }
}